import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { PublicRestaurantTag } from "src/data/clientBooking/queries/clientBooking";
import {
  colorPublicMenuChipBorder,
  colorPublicMenuChipText,
  colorPublicMenuDivider,
  colorPublicMenuTextMuted,
} from "src/design/tokens";

interface RestaurantTagsRowProps {
  tags?: PublicRestaurantTag[];
}

// Row of the restaurant's tags with a right-aligned pricing note, closed by a
// divider. Renders nothing when the restaurant has no tags.
export const RestaurantTagsRow = ({ tags }: RestaurantTagsRowProps) => {
  const { t } = useTranslation();

  if (!tags || tags.length === 0) return null;

  return (
    <Box sx={{ borderBottom: `1px solid ${colorPublicMenuDivider}`, pb: 3, mb: 4 }}>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 2,
        }}
      >
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
          {tags.map((tag) => (
            <Box
              key={tag.id}
              sx={{
                border: `1px solid ${colorPublicMenuChipBorder}`,
                color: colorPublicMenuChipText,
                borderRadius: "999px",
                px: 1.5,
                py: 0.5,
                fontSize: 11,
                fontWeight: 600,
                letterSpacing: "0.12em",
                textTransform: "uppercase",
              }}
            >
              {tag.name}
            </Box>
          ))}
        </Box>

        <Typography
          sx={{
            color: colorPublicMenuTextMuted,
            fontSize: { xs: 12, md: 13 },
            letterSpacing: "0.04em",
          }}
        >
          {t("publicMenu.priceNote")}
        </Typography>
      </Box>
    </Box>
  );
};
